import { render, staticRenderFns } from "./edit-unit.vue?vue&type=template&id=4682f218&"
import script from "./edit-unit.vue?vue&type=script&lang=ts&"
export * from "./edit-unit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports